/* eslint-disable */
<template>
    <!-- Services section start -->
	<section id="services-section" class="px-12 lg:px-32 py-16 relative overflow-hidden">
        <!-- Text wrapper start -->
        <div class="flex gap-8 flex-col md:flex-row">
            <!-- Main text start -->
            <!-- <h1 class="uppercase text-5xl mb-4 font-semibold ">
                OUR SERVICES
            </h1> -->
            <!-- <p class=" xl:w-1/2 text-stone-500 mb-8">
                Triple Palm Rehabilitation and Recovery Centre offers a comprehensive and holistic approach to addiction recovery and mental well-being. Our services include inpatient rehabilitation for alcohol and substance abuse, providing a safe and structured environment for recovery. We offer individual counseling and psychotherapy, family therapy, and spiritual therapy to address the emotional, psychological, and spiritual aspects of healing. Through psychoeducation, life skills development, and behavioral modification, we equip individuals with the tools they need for long-term sobriety. Our eco-therapy and group therapy foster a sense of connection and healing through nature and peer support. Additionally, we emphasize conflict resolution and the Twelve Steps Approach Program, ensuring a well-rounded recovery journey tailored to each individual’s needs.
                At Triple Palm Rehabilitation and Recovery Centre, we offer rehabilitation for individuals affected by alcohol and substance use, alongside personalized counseling, family therapy, and spiritual guidance. Our services also include life skills development, eco-therapy, conflict resolution, and the Twelve Steps approach to support lasting recovery. -->
            <!-- </p>  -->
            <div class="xl:w-1/2 text-stone-500 mb-8">
    <h2 class="text-2xl font-semibold text-gray-700 mb-4">Our Services</h2>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div class="flex items-center space-x-3">
            <span class="text-blue-500 text-xl">✔</span>
            <p>Inpatient Rehab for Alcohol & Substance Abuse</p>
        </div>
        <div class="flex items-center space-x-3">
            <span class="text-blue-500 text-xl">✔</span>
            <p>Individual Counseling & Psychotherapy</p>
        </div>
        <div class="flex items-center space-x-3">
            <span class="text-blue-500 text-xl">✔</span>
            <p>Family Therapy</p>
        </div>
        <div class="flex items-center space-x-3">
            <span class="text-blue-500 text-xl">✔</span>
            <p>Spiritual Therapy</p>
        </div>
        <div class="flex items-center space-x-3">
            <span class="text-blue-500 text-xl">✔</span>
            <p>Psychoeducation</p>
        </div>
        <div class="flex items-center space-x-3">
            <span class="text-blue-500 text-xl">✔</span>
            <p>Life Skills Development</p>
        </div>
        <div class="flex items-center space-x-3">
            <span class="text-blue-500 text-xl">✔</span>
            <p>Eco-Therapy</p>
        </div>
        <div class="flex items-center space-x-3">
            <span class="text-blue-500 text-xl">✔</span>
            <p>Conflict Resolution</p>
        </div>
        <div class="flex items-center space-x-3">
            <span class="text-blue-500 text-xl">✔</span>
            <p>Twelve Steps Approach Program</p>
        </div>
        <div class="flex items-center space-x-3">
            <span class="text-blue-500 text-xl">✔</span>
            <p>Behavioral Modification</p>
        </div>
        <div class="flex items-center space-x-3">
            <span class="text-blue-500 text-xl">✔</span>
            <p>Group Therapy</p>
        </div>
    </div>
</div>

            
            <!-- Main text end -->
        </div>
        <!-- Text wrapper end -->

        <!-- Services start -->
        <div class="flex flex-col md:flex-row md:gap-8">
            <!-- Wedding service start -->
            <div class="flex flex-row md:flex-col justify-between md:justify-start items-center md:items-start my-8 md:w-1/3">
                <img src="@/assets/therapy.jpg" alt="counseling" class="-z-50 hidden md:block">
                <div class="w-2/3 text-right md:text-left md:w-full">
                    <h1 class="uppercase text-2xl font-semibold">
                        Personalised counseling
                    </h1>
                    <p class=" text-stone-500">
                        At our rehab center, we prioritize personalized counseling as a vital element of our recovery process for individuals facing addiction. This tailored approach involves one-on-one sessions that address each person's unique challenges and goals, fostering a safe space for open dialogue and self-exploration. Through personalized treatment plans, our counselors help individuals develop coping strategies, build emotional resilience, and work towards sustainable recovery, all while nurturing a strong therapeutic relationship that supports their journey to wellness
                    </p>
                </div>
            </div>

            <div class="flex flex-row md:flex-col justify-between md:justify-start items-center md:items-start my-8 md:w-1/3">
                <img src="@/assets/12step.jpg" alt="12 step" class="-z-50 hidden md:block">
                <div class="w-2/3 text-right md:text-left md:w-full">
                    <h1 class="uppercase text-2xl font-semibold">
                        12 steps approach
                    </h1>
                    <p class=" text-stone-500 mt-[10px]">
                        At our rehab center, we implement the 12-step program as a core component of our recovery approach for individuals battling drug abuse. This structured framework encourages patients to acknowledge their addiction, seek support from a higher power, and foster accountability through group sharing and mutual support. By guiding individuals through self-reflection and personal growth, the program helps them develop coping strategies and build a strong foundation for lasting recovery within a nurturing community.
                    </p>
                </div>
            </div>
            
            <div class="flex flex-row md:flex-col justify-between md:justify-start items-center md:items-start my-8 md:w-1/3">
                <img src="@/assets/lifeskills.jpg" alt="12 step" class="-z-50 hidden md:block">
                <div class="w-2/3 text-right md:text-left md:w-full">
                    <h1 class="uppercase text-2xl font-semibold mt-[20px]">
                        Life skills development
                    </h1>
                    <p class=" text-stone-500 mt-[10px]">
                        At our rehab center, we offer personal life skills development as an essential part of our recovery program for individuals overcoming addiction. This initiative focuses on equipping participants with practical skills such as effective communication, stress management, and decision-making, empowering them to navigate everyday challenges. Through workshops and interactive sessions, individuals learn to build healthy relationships, set achievable goals, and enhance their self-esteem, fostering a sense of independence and resilience that supports their long-term recovery journey.
                    </p>
                </div>
            </div>
            <!-- Wedding service end -->
        </div>
        <!-- Services end -->

        <!-- Circle start -->
        <div class="bg-neutral-300 h-64 w-64 rounded-full absolute top-0 -right-20 mt-16 -z-20"></div>
        <!-- Circle end -->
	</section>
	<!-- Services section end -->
</template>

<script>
export default {

}
</script>

<style>

</style>